import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NamedLink from '../NamedLink/NamedLink';

import css from './TermsOfService.module.css';

const TermsOfService = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  // prettier-ignore
  return (
    <div className={classes}>
      {/* <p className={css.lastUpdated}>Last updated: November 22, 2019</p> */}

      <p>
        <strong>IMPORTANT: PLEASE READ THESE TERMS CAREFULLY BEFORE USING OUR SERVICES.</strong> By using our website or services, you agree to be legally bound by all terms of this agreement. If you do not
        agree to these terms, you may not use our website or services. These terms contain important provisions including binding arbitration and class action waiver provisions that affect your legal rights.
      </p>

      <p>
        If you provide testing services on our marketplace, please also review our
        {' '}<NamedLink name="TesterTermsOfServicePage" target="_blank" rel="noopener noreferrer">Tester Terms of Service</NamedLink>, which
        apply in addition to these Terms.
      </p>

      <h2>Eligibility</h2>
      <hr />
      <p>
        <strong>Age requirement:</strong> You must be at least 18 years old to access or use our website or services. By using the services, you represent and warrant that you are 18 years or older and have the legal capacity to enter into these Terms. If you are under 18, you may not use the services.
      </p>
      <hr />

      <h2>Services</h2>
      <hr />
      <p>
        We provide a marketplace platform where users can hire independent third-party testers to conduct loyalty tests on
        individuals of their choosing. We do not provide the testing services ourselves and are not
        responsible for the actions, conduct, quality of work, or any results of the testers or any third parties. We act solely as a platform facilitator and marketplace operator. All testing services are provided by independent contractors who are not our employees, agents, or representatives.
      </p>
      <hr />

      <h2>Refund and Cancellation Policy</h2>
      <hr />
      <p>
        You may cancel the service before the tester accepts your purchase request. You can request a refund
        if your tester does not perform the services as outlined in their package description. All refund requests are subject to our review and approval in our sole discretion.
      </p>
      <p>
        Please note that if your significant other or the test subject does not respond to contact attempts, this is considered a completed test and no refund will be provided. Dissatisfaction with test results or outcomes is not grounds for a refund.
      </p>
      <p>
        Refunds, if approved, may take up to 15 business days to process.
      </p>
      <hr />

      <h2>Legal Compliance</h2>
      <hr />
      <p>
        You agree to use our website and services only for lawful purposes and in compliance with
        all applicable laws and regulations. You will not use our website or services for any
        illegal or unethical purpose, including but not limited to deceiving or defrauding others, harassment, stalking, or any unlawful activity.
      </p>
      <p>
        You represent and warrant that your use of the services complies with all applicable laws in your jurisdiction, including but not limited to laws regarding consent, privacy, harassment, and fraud. You are solely responsible for ensuring your use of the services is lawful in your jurisdiction.
      </p>
      <hr />

      
      <h2>User Responsibility and Acknowledgment</h2>
      <hr />
      <p>
        You are solely responsible for any and all legal, financial, emotional, relational, or other consequences that may arise from your use of
        our services. You acknowledge that you have carefully considered the potential consequences of using loyalty testing services and have chosen to proceed voluntarily with full knowledge of the risks.
      </p>
      <p>
        You agree that we are not responsible for and shall have no liability for any results, outcomes, or consequences of testing services, including but not limited to: relationship problems or dissolution, emotional distress to you or others, financial losses, reputational harm, or any other negative outcomes.
      </p>
      <p>
        We will cooperate with law enforcement agencies as required by law. You acknowledge that your use of the services may be disclosed to law enforcement or other authorities if legally required.
      </p>
      <hr />

      <h2>NO LAWSUIT CLAUSE - BINDING ARBITRATION AND WAIVER OF RIGHTS</h2>
      <hr />
      <p>
        <strong>YOU AGREE THAT YOU CANNOT SUE US, OUR COMPANY, OUR TESTERS, OUR AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, OR ANY RELATED PARTIES IN COURT FOR ANY REASON WHATSOEVER.</strong> Instead, you agree to binding arbitration as the sole and exclusive remedy for resolving any and all disputes.
      </p>
      <p>
        By using our services, you expressly waive your right to file a lawsuit, seek injunctive relief, or pursue any legal action in any court of law. Any dispute, claim, or controversy arising out of or relating to these Terms, the services, or the breach, termination, enforcement, interpretation or validity thereof, including the determination of the scope or applicability of this agreement to arbitrate, shall be determined by binding arbitration before a single arbitrator, rather than in court.
      </p>
      <p>
        The arbitration shall be administered by a recognized arbitration association under its applicable rules. The arbitrator's decision shall be final and binding, and judgment on the award rendered by the arbitrator may be entered in any court having jurisdiction thereof. You agree that any arbitration shall be limited to the dispute between you and us individually.
      </p>
      <p>
        <strong>CLASS ACTION WAIVER:</strong> YOU AGREE THAT YOU MAY BRING CLAIMS AGAINST US ONLY IN YOUR INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS, REPRESENTATIVE, OR COLLECTIVE PROCEEDING. You waive any right to participate in class actions, class arbitrations, or any representative or collective actions of any kind.
      </p>
      <hr />

      <h2>COMPLETE RELEASE AND WAIVER OF LIABILITY</h2>
      <hr />
      <p>
        <strong>YOU HEREBY RELEASE, DISCHARGE, AND HOLD HARMLESS OUR COMPANY, ALL TESTERS ON OUR PLATFORM, AND ALL OF OUR AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AFFILIATES, SUCCESSORS, AND ASSIGNS FROM ANY AND ALL CLAIMS, LIABILITIES, DAMAGES, LOSSES, COSTS, OR EXPENSES OF ANY KIND WHATSOEVER, WHETHER KNOWN OR UNKNOWN, FORESEEN OR UNFORESEEN, ARISING OUT OF OR IN ANY WAY RELATED TO YOUR USE OF OUR SERVICES.</strong>
      </p>
      <p>
        This release applies to claims of any nature including but not limited to: personal injury, emotional distress, property damage, financial loss, reputational harm, relationship damage, breach of contract, negligence, fraud, misrepresentation, invasion of privacy, defamation, intentional or negligent infliction of emotional distress, or any other tort or legal theory.
      </p>
      <p>
        You acknowledge that relationship testing may result in emotional distress, relationship dissolution, financial consequences, or other negative outcomes, and you voluntarily assume all such risks. You agree that neither we nor any tester shall be liable for any consequences resulting from the testing services, regardless of the outcome.
      </p>
      <hr />

      <h2>LIMITATION OF LIABILITY AND DAMAGES</h2>
      <hr />
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL WE, OUR TESTERS, OR ANY OF OUR OR THEIR AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, RELATIONSHIPS, EMOTIONAL DISTRESS, OR OTHER INTANGIBLE LOSSES.
      </p>
      <p>
        OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THESE TERMS OR YOUR USE OF THE SERVICES SHALL NOT EXCEED THE LESSER OF: (A) THE TOTAL AMOUNT YOU PAID TO US IN THE SIX MONTHS PRECEDING THE EVENT GIVING RISE TO LIABILITY, OR (B) ONE HUNDRED DOLLARS ($100).
      </p>
      <p>
        These limitations apply regardless of the legal theory upon which the claim is based, whether contract, tort, negligence, strict liability, or otherwise, and even if we have been advised of the possibility of such damages. Some jurisdictions do not allow the exclusion or limitation of certain damages, so some of the above limitations may not apply to you.
      </p>
      <hr />

      <h2>DISCLAIMER OF WARRANTIES</h2>
      <hr />
      <p>
        THE SERVICES, PLATFORM, AND ALL CONTENT AND MATERIALS ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMISSIBLE UNDER APPLICABLE LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
      </p>
      <hr />

      <h2>INDEMNIFICATION; YOU PAY TO PROTECT US</h2>
      <hr />
      <p>
        <strong>IF YOU ARE SUED, THREATENED WITH A LAWSUIT, OR OTHERWISE INVOLVED IN ANY LEGAL CLAIM, DISPUTE, INVESTIGATION, OR PROCEEDING OF ANY KIND ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES, YOU CANNOT HOLD US LIABLE FOR ANYTHING.</strong> You agree that we, our testers, and all of our and their respective officers, directors, employees, agents, affiliates, successors, and assigns shall have no liability to you whatsoever in connection with any such lawsuit, claim, or proceeding, regardless of who brought it, what it alleges, or how it is resolved.
      </p>
      <p>
        <strong>YOU WILL PAY TO PROTECT US.</strong> You agree to indemnify, defend, and hold harmless our company, our testers, and all of our and their respective officers, directors, employees, agents, affiliates, successors, and assigns from and against any and all losses, damages, liabilities, deficiencies, claims, actions, lawsuits, investigations, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind, including attorneys' fees, court costs, expert fees, and all other costs of defense, arising out of or relating to:
      </p>
      <p>
        (a) Your use or misuse of the services; (b) Your breach of these Terms; (c) Your violation of any law, regulation, or rights of any third party; (d) Any content you submit or transmit through the services; (e) Any dispute, claim, or lawsuit you have with a tester, a test subject, or any third party; (f) Any lawsuit, claim, demand, or proceeding brought against you or against us in connection with your use of the services; (g) Any consequences arising from testing services you requested, including relationship damage, emotional distress, or financial loss; (h) Your relationships with any individuals who are the subject of testing services; or (i) Any negligent or willful misconduct by you.
      </p>
      <p>
        You will promptly pay all amounts necessary to defend us, including attorneys' fees and litigation costs, as they are incurred (not only after a final judgment). We may, at our option, control the defense and settlement of any matter subject to indemnification, and you will cooperate fully and pay all related costs. You will not settle any claim in a manner that imposes any obligation on us without our prior written consent.
      </p>
      <p>
        This indemnification obligation will survive termination of these Terms and your use of the services.
      </p>
      <hr />

      <h2>ASSUMPTION OF RISK</h2>
      <hr />
      <p>
        You acknowledge and agree that using loyalty testing services carries inherent risks, including but not limited to: relationship dissolution, emotional harm, reputational damage, financial consequences, disclosure of private information, and potential legal ramifications. You voluntarily assume all risks associated with using our services and engaging with testers.
      </p>
      <p>
        You understand that testers are independent contractors and not our employees, and we have no control over their actions, methods, judgment, or conduct. You assume all risks related to interactions with testers and the outcomes of any testing services.
      </p>
      <hr />

      <h2>Third-Party Services and Independent Contractors</h2>
      <hr />
      <p>
        All testers on our platform are independent third-party contractors who are solely responsible for their own actions, conduct, and the services they provide.
      </p>
      <hr />



      <h2>Privacy and Data Protection</h2>
      <hr />
      <p>
        We respect the privacy of our users and test subjects. You agree to our Privacy Policy,
        which can be found on our website. 
      </p>
      <p>
        We make no guarantees about data security and shall not be liable for any unauthorized access to, disclosure of, or loss of your data or information.
      </p>
      <hr />

      <h2>Prohibited Conduct</h2>
      <hr />
      <p>
        You agree not to: (a) violate any laws or regulations; (b) infringe upon the rights of others; (c) transmit any harmful, threatening, abusive, harassing, defamatory, or otherwise objectionable content; (d) interfere with or disrupt the services or servers; (e) attempt to gain unauthorized access to any portion of the platform; (f) use the services for any fraudulent or unlawful purpose; (g) impersonate any person or entity; or (h) collect or harvest any information about other users.
      </p>
      <p>
        Violation of these prohibitions may result in immediate termination of your access to the services, and we may pursue any available legal remedies.
      </p>
      <hr />

      <h2>Termination and Suspension</h2>
      <hr />
      <p>
        We reserve the right to terminate or suspend your access to the services at any time, for any reason or no reason, without notice or liability. Upon termination, your right to use the services will immediately cease. All provisions of these Terms that by their nature should survive termination shall survive, including but not limited to the arbitration clause, liability limitations, indemnification obligations, and disclaimers.
      </p>
      <hr />

      <h2>Governing Law and Jurisdiction</h2>
      <hr />
      <p>
        These Terms shall be governed by and construed in accordance with the laws of the State of Delaware, United States, without regard to its conflict of law provisions. To the extent arbitration does not apply, you agree that any legal action or proceeding shall be brought exclusively in the federal or state courts located in Delaware, and you consent to the personal jurisdiction of such courts.
      </p>
      <hr />

      <h2>Severability</h2>
      <hr />
      <p>
        If any provision of these Terms is found to be invalid, illegal, or unenforceable, the remaining provisions shall continue in full force and effect. The invalid or unenforceable provision shall be deemed modified to the minimum extent necessary to make it valid and enforceable. If such modification is not possible, the provision shall be severed from these Terms.
      </p>
      <hr />

      <h2>Force Majeure</h2>
      <hr />
      <p>
        We shall not be liable for any failure or delay in performance due to circumstances beyond our reasonable control,
      </p>
      <hr />

      <h2>Entire Agreement and Waiver</h2>
      <hr />
      <p>
        These Terms, together with our Privacy Policy and any other policies referenced herein, constitute the entire agreement between you and us regarding the use of the services and supersede all prior or contemporaneous understandings and agreements. Our failure to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.
      </p>
      <hr />

      <h2>Modification of Terms</h2>
      <hr />
      <p>
        We reserve the right to modify, amend, or update these terms of service at any time in our sole discretion, with or without notice. Any changes will be effective immediately upon posting to the website. Your continued use of our
        website or services after any changes are made constitutes your acceptance of the new terms. It is your responsibility to review these Terms periodically for updates.
      </p>
      <p>
        If you do not agree to any modifications, your sole remedy is to discontinue using the services. By continuing to use the services after changes are posted, you agree to be bound by the revised Terms.
      </p>
      <hr />

      <h2>Contact Information</h2>
      <hr />
      <p>
        If you have any questions or concerns about these terms of service, please contact us at {' '}
        <a href="mailto:contact@loyalty-test.com">contact@loyalty-test.com</a>. Please note that contacting us does not create any attorney-client relationship or modify these Terms in any way.
      </p>

      <p style={{ marginTop: '30px', fontStyle: 'italic', fontSize: '14px' }}>
        <strong>BY USING OUR SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS OF SERVICE, INCLUDING THE ARBITRATION CLAUSE, WAIVER OF CLASS ACTIONS, LIMITATION OF LIABILITY, AND RELEASE OF CLAIMS.</strong>
      </p>
    </div>
  );
};

TermsOfService.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

TermsOfService.propTypes = {
  rootClassName: string,
  className: string,
};

export default TermsOfService;
